import React from 'react';
import omit from 'lodash/omit';
import prettyBytes from 'pretty-bytes';
import mimer from 'mimer';
import { useTranslation } from 'react-i18next';

import { toMimes } from '../helpers';
import ModalAlert from './ModalAlert.jsx';

window.mimer = mimer;

const ModalFileAlert = (props) => {
  const { accept, maxSize, show } = props;
  const { t } = useTranslation();

  return (
    <ModalAlert
      show={Boolean(show)}
      {...omit(props, ['accept', 'maxSize', 'show'])}
    >
      <>
        {show === 'maxSize' && (
          <>
            {t('Your file exceeds the max file size')}:
            &nbsp;
            {prettyBytes(maxSize)}
          </>
        )}
        {show === 'accept' && (
          <>
          {t('Only accepts file types')}:
            <br />
            {toMimes(accept).join(', ')}
          </>
        )}
      </>
    </ModalAlert>
  );
};

export default ModalFileAlert;
